import dayjs from 'dayjs';
import * as yup from 'yup';

export const validationSchema = yup.object<PreCompraFormValues>().shape({
  folioInterno: yup.string().required('El folio interno es requerido'),
  fecha: yup.mixed<dayjs.Dayjs>().required('La fecha es requerida'),
  referencia: yup.string(),
  idPersonaVende: yup.number().moreThan(0, '"Vendido Por" es requerido'),
  vendidoPor: yup.string(),
  idPersonaRecibe: yup.number().moreThan(0, '"Recibido Por" es requerido'),
  recibidoPor: yup.string(),
  idPersonaEntrega: yup.number().moreThan(0, '"Entregado Por" es requerido'),
  entregadoPor: yup.string(),
  idCorral: yup.number().moreThan(0, '"Corral de Reciba" es requerido'),
  idZona: yup.number().moreThan(0, '"Zona" es requerido'),
  totalAnimales: yup.number().moreThan(0, '"Número de Animales" es requerido'),
  animales: yup
    .array()
    .of(
      yup.object<AnimalPreCompra>({
        areteSiiniga: yup.string(),
        areteTemporal: yup.string(),
        tienePapeles: yup.boolean(),
        reemo: yup.string().when('tienePapeles', {
          is: true,
          then: (schema) => schema.required('REEMO es requerido'),
          otherwise: (schema) => schema.notRequired()
        }),
        idTipoGanado: yup.number().moreThan(0, 'El tipo es requerido'),
        kgCompra: yup.number().moreThan(0, 'Los Kgs de compra son requeridos'),
        kgLlegada: yup.number().moreThan(0, 'Los Kgs de llegada son requeridos')
      })
    )
    .test({
      name: 'total',
      message: 'La cantidad de animales capturados debe ser igual al total de animales indicado',
      test: (values: any[] | undefined, context) => {
        const numAnimales = context.parent.totalAnimales;
        const capturados = values?.length ?? 0;
        return capturados === numAnimales;
      }
    })
    .test({
      name: 'SIINIGA-Temporal',
      message: 'Si el animal tiene arete SIINIGA, debe tener arete temporal, y viceversa',
      test: (values: any[] | undefined) => {
        if (!values) return true;
        return values.every((animal) => {
          const tieneSiiniga = !!animal.areteSiiniga;
          const tieneTemporal = !!animal.areteTemporal;
          return (tieneSiiniga || tieneTemporal);
        });
      }
    })
});

export interface PreCompraFormValues {
  folioInterno: string;
  fecha: dayjs.Dayjs;
  referencia: string;
  idPersonaVende: number;
  vendidoPor: string;
  idPersonaRecibe: number;
  recibidoPor: string;
  idPersonaEntrega: number;
  entregadoPor: string;
  idCorral: number;
  idZona?: number;
  totalAnimales: number;
  animales: Array<AnimalPreCompra>;
}

export interface AnimalPreCompra {
  id: string;
  partida: number;
  areteSiiniga: string;
  areteTemporal: string;
  tienePapeles: boolean;
  reemo: string;
  idTipoGanado: number;
  kgCompra: number;
  kgLlegada: number;
  // diferencialKg: number;
  // diferencialPorcentual: number;
}
